import '../pages/EditorialPages.css';
import SEO from './SEO';

const LegalPageLayout = ({ title, description, effectiveDate, children }) => (
  <div className="dv-editorial dv-editorial--legal" data-testid="legal-page">
    <SEO title={title} description={description} />
    <section className="dv-editorial__hero">
      <div className="container-custom dv-editorial__hero-inner">
        <h1 className="dv-size-heading text-4xl md:text-5xl font-bold">{title}</h1>
        {effectiveDate && <p className="text-blue-100 mt-3">Effective date: {effectiveDate}</p>}
      </div>
    </section>
    <section className="dv-editorial__section">
      <article className="container-custom dv-editorial__legal-body text-gray-700 leading-relaxed space-y-5 [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-gray-900 [&_h2]:pt-5 [&_h3]:text-xl [&_h3]:font-bold [&_h3]:text-gray-900 [&_h3]:pt-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_a]:text-[#0072BB] [&_a]:font-medium [&_a:hover]:underline">
        {children}
      </article>
    </section>
  </div>
);

export default LegalPageLayout;
